// StyledReturnButton.tsx
import { styled } from "leva/plugin";
import { ReactChild } from "react";

const Button = styled("button", {
	backgroundColor: "$accent1",
	width: "70px",
	height: "26px",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	borderRadius: "4px",
	border: "none",
	cursor: "pointer",
	transition: "background-color 0.2s, transform 0.15s",
	outline: "none",
	marginLeft: "auto",
	pointer: "auto",
	"&:hover": {
		backgroundColor: "$accent2",
	},

	"&:active": {
		backgroundColor: "#004d4d",
		transform: "scale(0.95)",
		transition: "background-color 0.1s, transform 0.1s",
	},
});

export const StyledReturnButton = ({
	onClick,
	onChange,
	children,
}: {
	onClick: () => void;
	onChange?: any;
	children?: ReactChild;
}) => (
	<Button onClick={onClick} onChange={onChange}>
		{
			children ? children : <span className="text-highlight3">Apply</span>
			// <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
			//   <path d="M13.3 0.400024C13.659 0.400024 13.9549 0.670253 13.9953 1.01839L14 1.10002V5.65002C14 6.95802 12.975 8.02661 11.6844 8.0964L11.55 8.10002H2.3905L4.69497 10.405C4.94731 10.6574 4.96672 11.0544 4.75321 11.3291L4.69497 11.395C4.44264 11.6473 4.04557 11.6667 3.77097 11.4532L3.70503 11.395L0.205025 7.895C0.180249 7.87022 0.157719 7.84405 0.137434 7.81674L0.0872699 7.73887L0.0498578 7.65996L0.0250915 7.58622L0.00771246 7.50395L0.00278428 7.46288L0 7.40002L0.00195148 7.34736L0.014168 7.25951L0.0348167 7.18152L0.0655714 7.10377L0.102197 7.03553L0.146793 6.97099L0.205025 6.90505L3.70503 3.40505C3.97839 3.13168 4.42161 3.13168 4.69497 3.40505C4.94731 3.65739 4.96672 4.05445 4.75321 4.32905L4.69497 4.395L2.3905 6.70002H11.55C12.0958 6.70002 12.5443 6.2836 12.5952 5.75114L12.6 5.65002V1.10002C12.6 0.713425 12.9134 0.400024 13.3 0.400024Z" fill="white"/>
			// </svg>
		}
	</Button>
);
